module.exports = __webpack_public_path__ + "static/what-is-impact-65054fb4178b3012a671047cbab03425.svg";